import { render } from "./PreviewPanel.vue?vue&type=template&id=707ba425&scoped=true"
import script from "./PreviewPanel.vue?vue&type=script&lang=ts"
export * from "./PreviewPanel.vue?vue&type=script&lang=ts"

import "./PreviewPanel.vue?vue&type=style&index=0&id=707ba425&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-707ba425"

export default script
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar});
